var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"xml-content"},[_c('header',{domProps:{"innerHTML":_vm._s(_vm.headerXml)}}),_c('div',{staticClass:"switch-lang"})])
}
var staticRenderFns = []

export { render, staticRenderFns }